module.exports = fox._r("images/ad_prev.png", __webpack_public_path__ + "images/ad_prev.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/ad_prev.png
// module id = 971
// module chunks = 4